import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles(() => ({
  urlBar: {
    background: '#16213e',
    padding: '14px 32px',
    borderBottom: '1px solid #0f3460',
  },
  urlRow: {
    display: 'flex',
    alignItems: 'center',
    gap: '12px',
    flexWrap: 'wrap',
  },
  urlBarLabel: {
    color: '#94a3b8',
    fontSize: '.78rem',
    fontWeight: 600,
    textTransform: 'uppercase',
    whiteSpace: 'nowrap',
  },
  urlInput: {
    minWidth: '160px',
    padding: '9px 14px',
    background: '#0f1f38',
    border: '1px solid #2d4a6e',
    borderRadius: '8px',
    color: '#e2e8f0',
    fontSize: '.88rem',
    fontFamily: "'SF Mono', 'Fira Code', monospace",
    '& input': {
      color: '#e2e8f0',
      padding: 0,
    },
  },
  submitBtn: {
    padding: '9px 22px',
    background: 'linear-gradient(135deg, #2563eb, #1d4ed8)',
    color: '#fff',
    borderRadius: '8px',
    fontWeight: 700,
    whiteSpace: 'nowrap',
    '&:hover': {
      opacity: 0.9,
      background: 'linear-gradient(135deg, #2563eb, #1d4ed8)',
    },
    '&:disabled': {
      opacity: 0.5,
    },
  },
  statsBar: {
    display: 'flex',
    gap: '14px',
    flexWrap: 'wrap',
    padding: '20px 32px 0',
  },
  statChip: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    background: 'linear-gradient(135deg, #1e40af, #2563eb)',
    color: '#fff',
    borderRadius: '10px',
    padding: '12px 20px',
    minWidth: '130px',
    flex: 1,
  },
  statChipGreen: {
    background: 'linear-gradient(135deg, #065f46, #059669)',
  },
  statChipBlue: {
    background: 'linear-gradient(135deg, #1e3a8a, #2563eb)',
  },
  statChipPurple: {
    background: 'linear-gradient(135deg, #4c1d95, #7c3aed)',
  },
  statChipOrange: {
    background: 'linear-gradient(135deg, #7c2d12, #c2410c)',
  },
  statChipVal: {
    fontSize: '1.4rem',
    fontWeight: 700,
  },
  statChipLbl: {
    fontSize: '.68rem',
    opacity: 0.8,
    letterSpacing: '.4px',
    textTransform: 'uppercase',
    marginTop: '2px',
  },
  statChipSub: {
    fontSize: '.72rem',
    marginTop: '3px',
    opacity: 0.9,
  },
  container: {
    padding: '20px 32px 32px',
  },
  card: {
    background: '#fff',
    borderRadius: '12px',
    boxShadow: '0 1px 6px rgba(0,0,0,0.07)',
    overflow: 'hidden',
    marginBottom: '20px',
  },
  filterBar: {
    display: 'flex',
    alignItems: 'center',
    gap: '10px',
    flexWrap: 'wrap',
    padding: '12px 18px',
    borderBottom: '1px solid #f1f5f9',
  },
  searchInput: {
    padding: '5px 12px',
    border: '1px solid #e5e7eb',
    borderRadius: '8px',
    fontSize: '.84rem',
    minWidth: '220px',
    background: '#fff',
    '& input': {
      color: '#374151',
    },
  },
  filterSelect: {
    padding: '6px 14px',
    border: '1px solid #e2e8f0',
    borderRadius: '8px',
    fontSize: '.84rem',
    background: '#fff',
    color: '#1e293b',
    cursor: 'pointer',
    minWidth: '130px',
  },
  selectPaper: {
    maxHeight: '300px',
  },
  filterRight: {
    display: 'flex',
    gap: '8px',
    alignItems: 'center',
    marginLeft: 'auto',
  },
  exportBtn: {
    padding: '8px 16px',
    background: '#f0fdf4',
    border: '1px solid #86efac',
    color: '#166534',
    borderRadius: '8px',
    fontSize: '.82rem',
    fontWeight: 700,
    '&:hover': {
      background: '#dcfce7',
    },
  },
  tableWrap: {
    overflowX: 'auto',
    maxHeight: 'calc(100vh - 360px)',
  },
  emptyState: {
    textAlign: 'center',
    padding: '60px 20px',
    color: '#9ca3af',
    fontSize: '.9rem',
  },
  emptyTableContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '60px 20px',
    color: '#9ca3af',
    fontSize: '.9rem',
    gap: '12px',
  },
  tableHeader: {
    fontWeight: 700,
    backgroundColor: '#335977',
    whiteSpace: 'nowrap',
  },
  isBold: {
    fontWeight: 700,
    color: '#FFFFFF',
  },
  piTable: {
    width: '100%',
    borderCollapse: 'collapse',
    fontSize: '0.8rem',
    '& thead th': {
      background: '#335977',
      padding: '11px 14px',
      textAlign: 'right',
      fontSize: '0.72rem',
      fontWeight: 700,
      color: '#FFE784',
      letterSpacing: '0.6px',
      textTransform: 'uppercase',
      borderBottom: '2px solid #e5e7eb',
      whiteSpace: 'nowrap',
    },
    '& thead th:first-child': {
      textAlign: 'left',
      position: 'sticky',
      left: 0,
      zIndex: 2,
      background: '#335977',
      minWidth: '210px',
    },
    '& thead th:nth-child(2)': {
      textAlign: 'left',
    },
    '& thead th:nth-child(3)': {
      textAlign: 'left',
    },
    '& thead th:nth-child(4)': {
      textAlign: 'left',
    },
    '& thead th:last-child': {
      textAlign: 'right',
    },
    '& tbody tr': {
      borderBottom: '1px solid #f1f5f9',
      transition: 'background 0.1s',
      '&:hover': {
        background: '#f8fafc',
      },
    },
    '& tbody td': {
      padding: '7px 15px',
      textAlign: 'right',
      verticalAlign: 'middle',
    },
    '& tbody td:first-child': {
      textAlign: 'left',
    },
    '& tbody td:nth-child(2)': {
      textAlign: 'left',
    },
  },
  piTh: {
    background: '#f8fafc',
    padding: '9px 10px',
    textAlign: 'right',
    fontSize: '.66rem',
    fontWeight: 700,
    letterSpacing: '.5px',
    textTransform: 'uppercase',
    color: '#6b7280',
    borderBottom: '2px solid #e5e7eb',
    whiteSpace: 'nowrap',
    cursor: 'pointer',
    userSelect: 'none',
    '&:hover': {
      color: '#374151',
    },
  },
  piThAccount: {
    textAlign: 'left',
    position: 'sticky',
    left: 0,
    zIndex: 11,
    background: '#f8fafc',
    borderRight: '1px solid #e5e7eb',
    minWidth: '210px',
  },
  piThLeft: {
    textAlign: 'left !important',
  },
  piThAmount: {
    color: '#065f46 !important',
    background: '#f0fdf4 !important',
  },
  sortIcon: {
    display: 'flex',
    alignItems: 'center',
  },
  sortContainer: {
    display: 'flex',
    flexDirection: 'column',
    marginLeft: '4px',
    cursor: 'pointer',
  },
  sortUp: {
    marginBottom: '-8px',
  },
  sortDown: {
    marginTop: '-4px',
  },
  active: {
    color: '#FFE784',
  },
  inactive: {
    color: '#b0bac6',
  },
  piRow: {
    borderBottom: '1px solid #f1f5f9',
    transition: 'background 0.1s',
    '&:hover': {
      background: '#f8fafc',
    },
  },
  piTd: {
    padding: '8px 10px',
    textAlign: 'right',
    verticalAlign: 'middle',
    whiteSpace: 'nowrap',
    color: '#374151',
  },
  piTdLeft: {
    padding: '8px 10px',
    textAlign: 'left',
    verticalAlign: 'middle',
    whiteSpace: 'nowrap',
    color: '#374151',
  },
  piTdCenter: {
    padding: '8px 10px',
    textAlign: 'center',
    verticalAlign: 'middle',
  },
  piTdAccount: {
    padding: '8px 10px',
    textAlign: 'left',
    position: 'sticky',
    left: 0,
    background: '#fff',
    zIndex: 1,
    borderRight: '1px solid #e5e7eb',
    minWidth: '210px',
    verticalAlign: 'middle',
  },
  piTdProg: {
    padding: '8px 10px',
    textAlign: 'left',
    verticalAlign: 'middle',
    minWidth: '200px',
    maxWidth: '280px',
  },
  piTdAmount: {
    background: '#f0fdf4 !important',
    borderLeft: '2px solid #86efac',
    fontWeight: 700,
    color: '#166534 !important',
  },
  titleWrapper: {
    padding: '8px 10px',
    textAlign: 'right',
    verticalAlign: 'middle',
    whiteSpace: 'nowrap',
    color: '#374151',
  },
  accountCell: {
    padding: '8px 10px',
    textAlign: 'left',
    position: 'sticky',
    left: 0,
    background: '#fff',
    zIndex: 1,
    borderRight: '1px solid #e5e7eb',
    minWidth: '210px',
    verticalAlign: 'middle',
  },
  programCell: {
    padding: '8px 10px',
    textAlign: 'left',
    verticalAlign: 'middle',
    minWidth: '200px',
    maxWidth: '280px',
  },
  amountCell: {
    background: '#f0fdf4 !important',
    borderLeft: '2px solid #86efac',
    fontWeight: 700,
    color: '#166534 !important',
  },
  acctName: {
    fontWeight: 600,
    fontSize: '.82rem',
    color: '#1e293b',
  },
  acctId: {
    fontSize: '.65rem',
    color: '#94a3b8',
    fontFamily: "'SF Mono','Fira Code',monospace",
    marginTop: '1px',
  },
  progName: {
    fontWeight: 600,
    fontSize: '.8rem',
    color: '#1e293b',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    maxWidth: '270px',
  },
  progId: {
    fontSize: '.62rem',
    color: '#94a3b8',
    fontFamily: "'SF Mono','Fira Code',monospace",
    marginTop: '1px',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    maxWidth: '270px',
  },
  curBadge: {
    display: 'inline-block',
    padding: '2px 8px',
    borderRadius: '20px',
    fontSize: '.7rem',
    fontWeight: 700,
  },
  curUsd: {
    background: '#f0fdf4',
    color: '#166534',
    border: '1px solid #86efac',
  },
  curEur: {
    background: '#eff6ff',
    color: '#1d4ed8',
    border: '1px solid #93c5fd',
  },
  dash: {
    color: '#d1d5db',
  },
  footRow: {
    borderTop: '2px solid #fde68a',
  },
  footTd: {
    background: '#fefce8 !important',
    fontWeight: 700,
    fontSize: '.78rem',
    padding: '8px 10px',
    color: '#92400e !important',
    textAlign: 'right',
    whiteSpace: 'nowrap',
  },
  footTdAccount: {
    textAlign: 'left !important',
    position: 'sticky',
    left: 0,
    zIndex: 1,
    background: '#fefce8 !important',
    borderRight: '1px solid #e5e7eb',
  },
  footTdAmount: {
    background: '#dcfce7 !important',
    borderLeft: '2px solid #86efac',
    color: '#166534 !important',
  },
  expandRow: {
    borderBottom: '1px solid #c7d2fe',
  },
  expandInner: {
    padding: 0,
  },
  grandTotalRow: {
    borderTop: '2px solid #fde68a',
  },
  grandTotalCell: {
    background: '#fefce8 !important',
    fontWeight: 700,
    fontSize: '.78rem',
    padding: '8px 10px',
    color: '#92400e !important',
    textAlign: 'right',
    whiteSpace: 'nowrap',
    borderTop: '2px solid #fde68a',
  },
  grandTotalAccountCell: {
    textAlign: 'left !important',
    position: 'sticky',
    left: 0,
    zIndex: 1,
    background: '#fefce8 !important',
    borderRight: '1px solid #e5e7eb',
  },
  grandTotalAmountCell: {
    background: '#dcfce7 !important',
    borderLeft: '2px solid #86efac',
    color: '#166534 !important',
  },
  configBtn: {
    display: 'inline-block',
    padding: '2px 8px',
    fontSize: '.65rem',
    background: '#e0e7ff',
    color: '#3730a3',
    borderRadius: '4px',
    fontWeight: 600,
    minWidth: 'auto',
    lineHeight: 1.5,
    '&:hover': {
      background: '#c7d2fe',
    },
  },
  expandCell: {
    padding: '0 !important',
    background: '#f8fafc',
    borderTop: '1px solid #e0e7ff',
    borderBottom: '2px solid #c7d2fe',
  },
  cfgPanel: {
    padding: '14px 22px 18px',
  },
  cfgMeta: {
    fontSize: '.72rem',
    color: '#6b7280',
    marginBottom: '8px',
  },
  cfgId: {
    fontFamily: 'monospace',
    fontSize: '.68rem',
    marginLeft: '8px',
  },
  cfgGrid: {
    display: 'flex',
    gap: '20px',
    flexWrap: 'wrap',
    alignItems: 'flex-start',
  },
  cfgSection: {
    minWidth: '160px',
  },
  cfgSectionTitle: {
    fontSize: '.66rem',
    fontWeight: 700,
    letterSpacing: '.8px',
    textTransform: 'uppercase',
    color: '#6b7280',
    marginBottom: '6px',
  },
  cfgTable: {
    borderCollapse: 'collapse',
    fontSize: '.76rem',
    '& td': {
      padding: '3px 10px',
      border: '1px solid #e5e7eb',
      textAlign: 'left',
    },
    '& td:first-child': {
      color: '#6b7280',
      whiteSpace: 'nowrap',
      background: '#f1f5f9',
    },
    '& td:last-child': {
      fontWeight: 600,
      color: '#1e293b',
    },
  },
  boolYes: {
    color: '#166534',
    background: '#dcfce7',
    padding: '0 5px',
    borderRadius: '3px',
    fontSize: '.68rem',
    fontWeight: 700,
  },
  boolNo: {
    color: '#991b1b',
    background: '#fee2e2',
    padding: '0 5px',
    borderRadius: '3px',
    fontSize: '.68rem',
    fontWeight: 700,
  },
}))

export { useStyles }
